import { set } from "@/utils/vuex";

export default {
  setList: set("list"),
  setLeadFromGridData: set("leadFromGridData"),
  setLeadForGridData: set("leadForGridData"),
};
